import React, { useState, useEffect, useRef, Fragment } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { SummaryIcons } from '../../icons/SummaryIcons';
import '../../QueuePage.scss';
import HrbTranslate from '../../../../components/language/HrbTranslate';
import { useHistory } from 'react-router-dom';
import { RouteConstants } from '../../../../router/services/RouteConstants';
import classnames from 'classnames';
import ReassignConfirmationModal from './ReassignConfirmationModal';
import ticketService from '../../../vdo-ticket/services/manage/TicketService'
import ReassignErrorModal from './ReassignErrorModal'
import { toast, Slide } from 'react-toastify'

const ReassignButtonDropdown = ({ reassignTicketIds, isAssociateQueue, officeId, associateFirstName, associateId, pageSelections }) => {
    const [expanded, setExpanded] = useState(false);
    const loggedInUserId = useSelector(state => (state.accountData.employeeId || []))
    const loggedInUserFirstName = useSelector(state => (state.accountData.firstName || []))
    const history = useHistory();
    const [dropdownClass, setDropdownClass] = useState('queue-table-reassign-disabled');
    const [dropdownTextClass, setDropdownTextClass] = useState('queue-table-reassign-text-disabled');
    const [confirmationModalShowing, setConfirmationModalShowing] = useState(false);
    const [showError, setShowError] = useState(false)
    const dropdownRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false)

    const handleDropdownExpand = () => {
        setExpanded(!expanded);
    };

    const handleReassignToAssociate = () => {
        history.push({
            pathname: RouteConstants.REASSIGN,
            state: {
                selectedTicketIds: reassignTicketIds,
                parentOfficeId: officeId,
                parentAssociateFirstName: associateFirstName,
                parentAssociateId: associateId,
                isAssociateQueue: isAssociateQueue,
                pageSelections: pageSelections
            }
        });
    };

    useEffect(() => {
        setDropdownClass('queue-table-reassign-disabled')

        document.addEventListener('click', handleOutsideClick);
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [])

    useEffect(() => {
        // manage the display of toast
        const showSuccessToast = localStorage.getItem('showSuccessToast');
        if (showSuccessToast) {
            const { ticketsCount, assigneeFirstName } = JSON.parse(showSuccessToast);
            toast.success(
                <HrbTranslate text='QueuePage.Labels.ReassignmentSuccess' params={{ ticketsCount: ticketsCount, AssigneeFirstName: assigneeFirstName }} />,
                {
                    className: 'black-background-toast',
                    position: "bottom-left",
                    autoClose: 5000,
                    transition: Slide,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                }
            );

            localStorage.removeItem('showSuccessToast');
        }
    }, [])

    const handleOutsideClick = (event) => {
        if ( dropdownRef.current && !dropdownRef.current.contains(event.target) ) {
            setExpanded(false);
        }
    };

    useEffect(() => {
        if (reassignTicketIds?.length === 0 || reassignTicketIds?.length === undefined) {
            setDropdownClass('queue-table-reassign-disabled')
            setDropdownTextClass('queue-table-reassign-text-disabled')
            setExpanded(false);
        } else {
            setDropdownClass('queue-table-reassign-enabled');
            setDropdownTextClass('')
        }
    }, [reassignTicketIds])

    const showReassignConfirmationModal = () => {
        setConfirmationModalShowing(true);
    }
    const onConfirmationModalClose = () => {
        setConfirmationModalShowing(false)
        setExpanded(false)
    }

    const handleBulkReassignment = async () => {
        setIsLoading(true)
        let result = await ticketService.bulkAssignTickets(reassignTicketIds, loggedInUserId, officeId, false, true);
        if (result) {
            localStorage.setItem('reassignTicketIds', JSON.stringify([]));
            localStorage.setItem('pageSelections', JSON.stringify({}));
            localStorage.setItem('showSuccessToast', JSON.stringify({
                ticketsCount: reassignTicketIds?.length,
                assigneeFirstName: loggedInUserFirstName
            }));
            setConfirmationModalShowing(false)
            setIsLoading(false)
            window.location.reload();
        }
        else {
            setShowError(true)
            setIsLoading(false)
        }
    }

    return (
        <Fragment>
            <div className='queue-table-reassign'>
                <div onClick={handleDropdownExpand} ref={dropdownRef} className={classnames(dropdownClass, { 'dropdown-expanded': expanded })}>
                    <div className={classnames('queue-table-reassign-text', dropdownTextClass)}>
                        <HrbTranslate text='QueuePage.Labels.ReassignButtonDropdown' />
                    </div>
                    <div className='queue-table-reassign-icon'>
                        {expanded || !(reassignTicketIds?.length === 0 || reassignTicketIds?.length === undefined) ? SummaryIcons.REASSIGN_DROPDOWN_EXPANDED : SummaryIcons.REASSIGN_DROPDOWN}
                    </div>
                </div>
                {expanded && dropdownClass !== 'queue-table-reassign-disabled' &&
                    <div className='queue-table-dropdown-expanded'>
                        <div onClick={handleReassignToAssociate} className='queue-table-dropdown-expanded-menuitem'><HrbTranslate text='QueuePage.Labels.ReassignDropdownToAnAssociate' /></div>
                        {isAssociateQueue &&
                            <div onClick={showReassignConfirmationModal} className='queue-table-dropdown-expanded-menuitem'><HrbTranslate text='QueuePage.Labels.ReassignDropdownToMe' /></div>}
                    </div>}
                {confirmationModalShowing &&
                    <ReassignConfirmationModal
                        onClose={onConfirmationModalClose}
                        handleBulkReassignment={handleBulkReassignment}
                        textContent={<HrbTranslate text='QueuePage.Labels.ReassignModalContent_toSelf' params={{ ticketsCount: reassignTicketIds?.length }} />}
                        isLoading={isLoading}
                    />
                }
            </div>
            {showError &&
                <ReassignErrorModal onClose={() => { setShowError(false) }} />
            }
        </Fragment>
    )
}

ReassignButtonDropdown.propTypes = {
    onClick: PropTypes.func
}

export default ReassignButtonDropdown